import { Alert } from './alert'

export interface PatientRecentAlertsState {
	alerts: Array<Alert>
	selectedAlerts: Array<string>
	sortByDate: string
}

export interface HandleAlertReqBody {
	phoneCall: boolean
	message: boolean
	chat: boolean
	email: boolean
	sms: boolean
	note: boolean
	questioner: boolean
	calendar: boolean
	notes: string
	applyAllAlerts: boolean
	selectedAlerts: Array<string>
}

export enum PATIENT_RECENT_ALERTS_ACTION_TYPES {
	GET = 'RECENT_ALERTS_GET',
	UPDATE = 'RECENT_ALERTS_UPDATE',
	SELECT = 'SELECT_RECENT_ALERT',
	SORT_BY_DATE = 'SORT_BY_DATE',
	SELECT_ALL = 'SELECT_ALL_RECENT_ALERTS'
}

export interface GetPatientRecentAlertsAction {
	type: PATIENT_RECENT_ALERTS_ACTION_TYPES.GET
	payload: Array<Alert>
}

export interface UpdatePatientRecentAlerts {
	type: PATIENT_RECENT_ALERTS_ACTION_TYPES.UPDATE
	payload: Array<Alert>
}

export interface SelectPatientAlertAction {
	type: PATIENT_RECENT_ALERTS_ACTION_TYPES.SELECT
	payload: string
}

export interface SelectAllPatientAlertAction {
	type: PATIENT_RECENT_ALERTS_ACTION_TYPES.SELECT_ALL
	payload: Array<string>
}

export interface PatientAlertsSortByDate {
	type: PATIENT_RECENT_ALERTS_ACTION_TYPES.SORT_BY_DATE
	payload: string
}

export type ReactAlertAction =
	| GetPatientRecentAlertsAction
	| SelectPatientAlertAction
	| UpdatePatientRecentAlerts
	| PatientAlertsSortByDate
	| SelectAllPatientAlertAction
